// src/hooks/useImageUpload.js
import { useState, useCallback } from 'react';

const useImageUpload = (noteId, onUploadSuccess) => {
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);
  const [isPendingUpload, setPendingUpload] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);
  const [isDescriptionModalOpen, setDescriptionModalOpen] = useState(false);

  const uploadImage = useCallback(async (file, description = 'Untitled') => {
    setIsUploading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('description', description);

      const response = await fetch(`http://172.234.197.110:8000/api/notes/${noteId}/images`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.statusText}`);
      }

      const result = await response.json();
      console.log('Upload successful, calling onUploadSuccess');
      onUploadSuccess?.(result);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsUploading(false);
      setPendingUpload(false);
      setPendingFile(null);
    }
  }, [noteId, onUploadSuccess]);

  const handlePastedImage = useCallback(async (event) => {
    const items = event.clipboardData?.items;
    const imageItem = Array.from(items).find(item => item.type.startsWith('image'));

    if (!imageItem) {
      return null;
    }

    const file = imageItem.getAsFile();
    if (!file) {
      return null;
    }

    setPendingFile(file);
    setPendingUpload(true);
    setDescriptionModalOpen(true);
  }, []);

  const handleDescriptionSave = useCallback(async (description) => {
    if (pendingFile) {
      try {
        await uploadImage(pendingFile, description);
      } catch (err) {
        setError('Failed to upload image: ' + err.message);
      }
    }
    setDescriptionModalOpen(false);
  }, [pendingFile, uploadImage]);

  const cancelPendingUpload = useCallback(() => {
    setPendingUpload(false);
    setPendingFile(null);
    setDescriptionModalOpen(false);
  }, []);

  const reset = useCallback(() => {
    setError(null);
    setIsUploading(false);
    setPendingUpload(false);
    setPendingFile(null);
    setDescriptionModalOpen(false);
  }, []);

  return {
    uploadImage,
    handlePastedImage,
    isUploading,
    error,
    reset,
    isDescriptionModalOpen,
    handleDescriptionSave,
    cancelPendingUpload
  };
};

export default useImageUpload;